import axios from 'axios'
import notifService from '../../services/notifService'

export const getBanner = async (context, val) => {
  let res = await axios
    .get('/cms/banners', {
      params: val
    })
    .then(response => {
      context.commit('getBanner', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
        return false
      }
    })

  return res
}

export const listBanner = async (context, val) => {
  let res = await axios
    .get('/cms/banners/list')
    .then(response => {
      context.commit('listBanner', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const setDetail = (context, val) => {
  context.commit('setDetail', val)
}

export const addBanner = async (context, val) => {
  let res = await axios
    .post('cms/banners/add', val)
    .then(response => {
      // commit('setRolePermission', response.data.data)
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const editBanner = async (context, val) => {
  let res = await axios
    .put('cms/banners/edit/' + val.id, val.data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(response => {
      // commit('setRolePermission', response.data.data)
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const deleteBanner = async (context, val) => {
  let res = await axios
    .delete('cms/banners/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}
